import axios from "axios";

export const useCreate = async (url, payload = {}) => {
  return await axios.post(url, payload, {
    headers: { session: localStorage.getItem("session_id") },
  });
};
